<template>
  <div id="app">
    <HelloWorld />
    <div class="container pt-4">
      <NameCard />
      <BadgeList title="관심분야" />
      <ItemList title="프로젝트" :items="projects" />
      <ItemList v-if="posts.length" title="포스트" :items="posts" />

      <Contact />
    </div>
  </div>
</template>

<script lang="js">
import Vue from "vue"
import HelloWorld from "./components/HelloWorld.vue"
import NameCard from "./components/NameCard.vue"
import BadgeList from "./components/BadgeList.vue"
import ItemList from "./components/ItemList.vue"
import Contact from "./components/Contact.vue"

import { projects } from "./data"


export default Vue.extend({
  name: "App",
  components: {
    HelloWorld,
    NameCard,
    BadgeList,
    ItemList,
    Contact
  },
  data() {
    return {
      projects,
      posts: [],
    }
  },
  created() {
    this.$api.get(
      "https://grpajyon5g.execute-api.ap-northeast-2.amazonaws.com/"
    ).then(res => {
      res.data.map(post => {
        const {title, thumbnail, short_description, tags, url_slug} = post
        return {
          title,
          img: thumbnail,
          desc: short_description,
          stack: tags,
          outlink: `https://velog.io/@supermoony/${url_slug}`
        }
      }).forEach(element => {
      this.posts.push(element)
    });
    })
    
  }
})
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html,
body {
  padding: 0;
  margin: 0;
}
</style>
